export default __webpack_public_path__ + "src/components/pages/placement/shared/images/5835f05060522e991e5a04dc19011647.png";